<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/score')" style="cursor: pointer">Riesgo Crediticio</li>
        <li class="breadcrumb-item active" aria-current="page">Búscar</li>
      </ol>
    </nav>
    <div class="container">
      <vx-card class="mt-5" title="Buscar persona física">
        <vs-input label="RFC" v-model="query" @keyup.enter="search()"></vs-input>
      </vx-card>
  
      <vx-card
        class="mt-5"
        title="Resultados de la busqueda">
  
        <vs-table :data="people" stripe>
          <template slot="header">
            <vs-th>Nombre</vs-th>
            <vs-th>RFC</vs-th>
            <vs-th>CURP</vs-th>
            <vs-th>País origen</vs-th>
            <vs-th>Opciones</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr v-for="person in data">
              <vs-td>{{person|full_name}}</vs-td>
              <vs-td>{{person.rfc}}</vs-td>
              <vs-td>{{person.curp}}</vs-td>
              <vs-td>{{person.origin_country||'Sin País de origen'}}</vs-td>
              <vs-td>
                <vs-tooltip title="Revisar score crediticio">
                  <span>
                    <vs-icon
                      @click="$router.push(`/score/personal-profile/${person.id}`)"
                      class="mt-1 cursor-pointer" icon="verified" size="small" color="green"></vs-icon>
                  </span>
                </vs-tooltip>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data: () => ({
    query: '',
    people: []
  }),
  filters: {
    full_name(person) {
      let full_name = [person.first_name, person.second_name, person.last_name_1, person.last_name_2].join(" ")
      return full_name.toUpperCase();
    }
  },
  methods: {
    async search() {
      if(this.query !== "") {
        const {data} = await axios.post(`/api/personal-profile/search`, {
          query: this.query
        })

        this.people = data;
      }
    }
  }
}
</script>

<style scoped>

</style>
